import { cx } from '@linaria/core';

import LoaderSvg from '~public/assets/icons/loader.svg';

import { LoaderWrapper } from './styles';

export type LoaderProps = {
	size?: number;
	plane?: boolean;
	className?: string;
};

export const Loader = ({ size = 60, plane, className }: LoaderProps) => (
	<LoaderWrapper className={cx('loader', className)} size={size} plane={plane}>
		<LoaderSvg />
	</LoaderWrapper>
);
